// extracted by mini-css-extract-plugin
export default {"wrapper":"LearningPath_wrapper__88ith","containerTop":"LearningPath_containerTop__E31So"};